const template = `
<div class="bottom-conditions">
	<form>
	  <div class="ownwinpercentage-update-wrapper">
      %distribution-updated-at% <button type="button">%button-update%</button>
    </div>

		<div class="conditions-container bet-distribution">
			<h2>%bet-distribution-header%</h2>
			<div class="conditions-inner" data-name="minPlayworthyRow">
				<div class="rows">

					<div class="row" data-sticky-template="bottom-conditions-bet-distribution-row">
					<label>%play-only% <input type="number" inputmode="numeric" class="bet-distribution-value" name="minPlayworthyRow" min="-1" max="999">%bet-distribution%</label>
					</div><!-- ROW -->
				</div>

			</div>
		</div><!-- CONTAINER -->

		<div class="conditions-container underplayed-horses">
			<h2>%underplayed-horses-header%</h2>
			<div class="conditions-inner" data-name="minUnderplayedHorses">
				<div class="rows">
					<div class="row" data-sticky-template="bottom-conditions-underplayed-horses-row">
					<label class="mr-1">%Min%
					<div class="styled-select">
						<select class="owneval-select from-points" name="minUnderplayedHorses"></select>
						<span class="sprite dropdown"></span>
					</div></label>
					<label class="mr-20">%max%
						<div class="styled-select">
							<select class="owneval-select to-points" name="maxUnderplayedHorses"></select>
							<span class="sprite dropdown"></span>
						</div>%underplayed-horses%</label>
					</div><!-- ROW -->
				</div>
			</div>
		</div><!-- CONTAINER -->

		<div class="conditions-container underplayed-must-win">
			<h2>%underplayed-must-win-header%</h2>
			<div class="conditions-inner" data-name="minMostUnderplayedHorses">
				<div class="rows">
				<div class="row" data-sticky-template="bottom-conditions-underplayed-must-win-row">
				<label>%Min%
				<div class="styled-select">
					<select class="owneval-select min-underplayed" name="minMostUnderplayedHorses"></select>
					<span class="sprite dropdown"></span>
				</div>%must-win%</label>
				</div><!-- ROW -->
				</div>
			</div>
		</div><!-- CONTAINER -->

		<div class="conditions-container overplayed-horses">
			<h2>%overplayed-horses-header%</h2>
			<div class="conditions-inner" data-name="minOverplayedHorses">
				<div class="rows">
					<div class="row" data-sticky-template="bottom-conditions-overplayed-horses-row">
					<label class="mr-1">%Min%
					<div class="styled-select">
						<select class="owneval-select from-points" name="minOverplayedHorses"></select>
						<span class="sprite dropdown"></span>
					</div></label>
					<label class="mr-20">%max%
						<div class="styled-select">
							<select class="owneval-select to-points" name="maxOverplayedHorses"></select>
							<span class="sprite dropdown"></span>
						</div>%overplayed-horses%</label>
					</div><!-- ROW -->
				</div>
			</div>
		</div><!-- CONTAINER -->

		<div class="conditions-container overplayed-must-win">
			<h2>%overplayed-must-win-header%</h2>
			<div class="conditions-inner" data-name="maxMostOverplayedHorses">
				<div class="rows">
				<div class="row" data-sticky-template="bottom-conditions-overplayed-must-win-row">
				<label>%max%
				<div class="styled-select">
					<select class="owneval-select max-overplayed" name="maxMostOverplayedHorses"></select>
					<span class="sprite dropdown"></span>
				</div>%should-win%</label>
					</div><!-- ROW -->
				</div>
			</div>
		</div><!-- CONTAINER -->

		<input type="submit" class="submit">
	</form>
</div>
`;

export default template;
